<template>
  <svg
    :class="$options.name"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    :height="size"
    :width="size"
  >
    <g fill="none" fill-rule="evenodd">
      <path v-for="icon in filteredIcons" :key="icon.name" fill="currentColor" :d="icon.path"></path>
    </g>
  </svg>
</template>
<script>
export default {
  name: "Icon",
  computed: {
    filteredIcons() {
      let iconName = this.name;
      return this.icons.filter(icon => {
        return icon.name === iconName;
      });
    }
  },
  data() {
    return {
      icons: [
        {
          name: "arrow-left",
          path:
            "M6 18l3.6 4.8a2 2 0 1 1-3.2 2.4L.412 17.216A1.991 1.991 0 0 1 0 16c0-.458.154-.88.412-1.216L6.4 6.8a2 2 0 1 1 3.2 2.4L6 14h24a2 2 0 1 1 0 4H6z"
        },
        {
          name: "arrow-right",
          path:
            "M26 18H2a2 2 0 1 1 0-4h24l-3.6-4.8a2 2 0 1 1 3.2-2.4l5.988 7.984c.258.337.412.759.412 1.216 0 .458-.154.88-.412 1.216L25.6 25.2a2 2 0 1 1-3.2-2.4L26 18z"
        },
        {
          name: "external",
          path:
            "M32 2.14V16a2 2 0 1 1-4 0V6.828L3.414 31.414a2 2 0 0 1-2.828-2.828L25.172 4H16a2 2 0 1 1 0-4h14c1.255 0 2.068 1.068 2 2.14z"
        },
        {
          name: "cancel",
          path:
            "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-13.172l3.586 3.586a2 2 0 0 0 2.828-2.828L18.828 16l3.586-3.586a2 2 0 0 0-2.828-2.828L16 13.172l-3.586-3.586a2 2 0 0 0-2.828 2.828L13.172 16l-3.586 3.586a2 2 0 0 0 2.828 2.828L16 18.828z"
        },
        {
          name: "search",
          path:
            "M17.487 22.675A11.949 11.949 0 0 1 12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12c0 2.461-.74 4.75-2.012 6.653l9.019 8.117a3 3 0 1 1-4.014 4.46l-9.506-8.555zM12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
        },
        {
          name: "social-facebook",
          path:
            "M1.765 0C.791 0 0 .79 0 1.765v28.47C0 31.21.79 32 1.765 32h15.326V19.608h-4.172V14.78h4.172v-3.567c0-4.132 2.525-6.38 6.212-6.38 1.766 0 3.285.13 3.728.188v4.32h-2.562c-2 0-2.389.962-2.389 2.362v3.081h4.779l-.62 4.84H22.08V32h8.153c.978 0 1.767-.79 1.767-1.765V1.765C32 .791 31.21 0 30.235 0H1.765z"
        },
        {
          name: "social-instagram",
          path:
            "M16 0c-4.347 0-4.89.02-6.596.096C7.7.176 6.54.444 5.52.84a7.835 7.835 0 0 0-2.835 1.845A7.807 7.807 0 0 0 .84 5.52C.444 6.54.175 7.7.096 9.404.016 11.111 0 11.654 0 16c0 4.347.02 4.89.096 6.596.08 1.703.348 2.864.744 3.884a7.847 7.847 0 0 0 1.845 2.835A7.824 7.824 0 0 0 5.52 31.16c1.021.395 2.181.665 3.884.744 1.707.08 2.25.096 6.596.096 4.347 0 4.89-.02 6.596-.096 1.703-.08 2.864-.35 3.884-.744a7.864 7.864 0 0 0 2.835-1.845 7.813 7.813 0 0 0 1.845-2.835c.395-1.02.665-2.181.744-3.884.08-1.707.096-2.25.096-6.596 0-4.347-.02-4.89-.096-6.596-.08-1.703-.35-2.865-.744-3.884a7.853 7.853 0 0 0-1.845-2.835A7.796 7.796 0 0 0 26.48.84C25.46.444 24.299.175 22.596.096 20.889.016 20.346 0 16 0zm0 2.88c4.27 0 4.78.021 6.467.095 1.56.073 2.406.332 2.969.553.75.29 1.28.636 1.843 1.195.558.56.905 1.092 1.194 1.841.219.563.48 1.41.551 2.97.076 1.687.093 2.194.093 6.466s-.02 4.78-.098 6.467c-.082 1.56-.342 2.406-.562 2.969-.298.75-.638 1.28-1.198 1.843a4.992 4.992 0 0 1-1.84 1.194c-.56.219-1.42.48-2.98.551-1.699.076-2.199.093-6.479.093-4.281 0-4.781-.02-6.479-.098-1.561-.082-2.421-.342-2.981-.562-.759-.298-1.28-.638-1.839-1.198a4.858 4.858 0 0 1-1.2-1.84c-.22-.56-.478-1.42-.56-2.98-.06-1.68-.081-2.199-.081-6.459 0-4.261.021-4.781.081-6.481.082-1.56.34-2.419.56-2.979.28-.76.639-1.28 1.2-1.841C5.22 4.12 5.741 3.76 6.5 3.48 7.06 3.26 7.901 3 9.461 2.92c1.7-.06 2.2-.08 6.479-.08l.06.04zm0 4.904A8.215 8.215 0 0 0 7.784 16c0 4.54 3.68 8.216 8.216 8.216 4.54 0 8.216-3.68 8.216-8.216 0-4.54-3.68-8.216-8.216-8.216zm0 13.55A5.332 5.332 0 0 1 10.667 16 5.332 5.332 0 0 1 16 10.667 5.332 5.332 0 0 1 21.333 16 5.332 5.332 0 0 1 16 21.333zM26.461 7.46c0 1.06-.861 1.92-1.92 1.92-1.06 0-1.92-.861-1.92-1.92a1.921 1.921 0 0 1 3.84 0z"
        },
        {
          name: "social-twitter",
          path:
            "M31.937 6.097c-1.18.519-2.44.872-3.766 1.033a6.61 6.61 0 0 0 2.884-3.63 13.55 13.55 0 0 1-4.17 1.579 6.56 6.56 0 0 0-11.348 4.477c.001.52.061 1.02.17 1.498-5.453-.257-10.286-2.876-13.52-6.834a6.429 6.429 0 0 0-.888 3.3 6.56 6.56 0 0 0 2.917 5.46 6.539 6.539 0 0 1-2.97-.82v.08a6.564 6.564 0 0 0 5.26 6.437 6.661 6.661 0 0 1-2.949.113 6.582 6.582 0 0 0 6.139 4.556 13.157 13.157 0 0 1-8.136 2.806c-.52 0-1.039-.03-1.56-.089a18.66 18.66 0 0 0 10.076 2.945c12.071 0 18.664-9.994 18.664-18.647 0-.279 0-.56-.02-.84 1.281-.919 2.4-2.08 3.28-3.397l-.063-.027z"
        },
        {
          name: "sun",
          path:
            "M14 2a2 2 0 1 1 4 0v4a2 2 0 1 1-4 0V2zm0 24a2 2 0 1 1 4 0v4a2 2 0 1 1-4 0v-4zm16-12a2 2 0 1 1 0 4h-4a2 2 0 1 1 0-4h4zM6 14a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4h4zM4.686 7.515a2 2 0 0 1 2.829-2.829l2.828 2.829a2 2 0 0 1-2.828 2.828L4.686 7.515zm16.97 16.97a2 2 0 0 1 2.83-2.828l2.828 2.828a2 2 0 1 1-2.829 2.829l-2.828-2.829zm2.83-19.799a2 2 0 1 1 2.828 2.829l-2.829 2.828a2 2 0 0 1-2.828-2.828l2.828-2.829zM7.514 21.656a2 2 0 0 1 2.828 2.83l-2.828 2.828a2 2 0 1 1-2.829-2.829l2.829-2.828zM16 21a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"
        }
      ]
    };
  },
  props: {
    name: { default: "arrow-left" },
    size: { default: 32 }
  }
};
</script>